<template>
  <div class="screen" id="change-username">
    <Panel class="change-username-panel" v-bind:class="{loading: userDataFetching}" :oncloseroute="'/profile'">
      <template #panel-content>
        <LoadyBro v-if="userDataFetching"></LoadyBro>
        <div v-else class="forms">
          <EmbeddedDarkBox class="lighter change-username-form">
            <template #dark-box-content>
              <div class="form-title">Change Username</div>
              <p class="error" v-if="changeUsername.error">{{changeUsername.error}}</p>
              <div class="input-group">
                <div class="input-label">
                  <label for="change-username-username">New Username</label>
                </div>
                <div class="input">
                  <input
                    v-on:keyup.enter="() => { changeUsernameFormSubmit() }"
                    v-model="changeUsername.newUsername"
                    id="change-username-username"
                    type="text"
                  />
                </div>
              </div>
              <div class="input-group">
                <div class="input-label">
                  <label for="change-username-username-confirmation">Confirm New Username</label>
                </div>
                <div class="input">
                  <input
                    v-on:keyup.enter="() => { changeUsernameFormSubmit() }"
                    v-model="changeUsername.newUsernameConfirmation"
                    id="change-username-username-confirmation"
                    type="text"
                  />
                </div>
              </div>
              <div class="form-submit-btn">
                <Button :color="'green'" :onclickfn="() => { changeUsernameFormSubmit() }" :text="'Change'"></Button>
              </div>
            </template>
          </EmbeddedDarkBox>
        </div>
      </template>
    </Panel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { some, values } from "lodash"
import Panel from "../reusable-components/Panel"
import EmbeddedDarkBox from "../reusable-components/EmbeddedDarkBox"
import Checkbox from "../reusable-components/Checkbox"
import Button from "../reusable-components/Button"
import LoadyBro from "../reusable-components/LoadyBro"
import {filter, additionalProfanityCheck } from "../utils/profanityFilter"
import sanitizeInput from "../utils/symbolAndDoubleScrubber"

export default {
	name: "ChangeUsername",
	components: {
		Panel,
		EmbeddedDarkBox,
		Checkbox,
		Button,
		LoadyBro
	},
	data() {
		return {
			changeUsername: {
				error: false,
				newUsername: "",
				newUsernameConfirmation: ""
			}
		}
	},
	computed: {
		...mapGetters("user", ["userDataFetching"])
	},
	methods: {
		...mapActions("user", ["submitChangeUsername"]),
		changeUsernameFormSubmit() {
			this.changeUsername.error = false

			let normalizedFormValues = {
				newUsername: this.changeUsername.newUsername,
				newUsernameConfirmation: this.changeUsername.newUsernameConfirmation
			}

			if (
				some(values(normalizedFormValues), v => {
					return v === undefined || v === ""
				})
			) {
				return (this.changeUsername.error = "You need to fill out the entire form.")
			}

			let sanitizedName = sanitizeInput(normalizedFormValues.newUsername)
			if(filter.isProfane(sanitizedName) || additionalProfanityCheck(filter, sanitizedName)) {
				return (this.changeUsername.error = "Detected profane language in your name.")
			}

			this.submitChangeUsername(normalizedFormValues)
		}
	}
}
</script>


<style lang="scss">
#change-username {
	.change-username-panel {
		position: relative;

		&.loading {
			width: 840px;
			height: 559px;
		}

		.loady-bro {
			position: absolute;
			top: 65%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.forms {
			display: flex;
		}

		.change-username-form {
			position: relative;
			display: flex;
			flex-direction: column;
			padding: 30px 30px 50px 30px;
			min-width: 380px;

			p.error {
				text-align: center;
				color: red;
			}

			.form-title {
				text-align: center;
				font-size: 32px;
				text-transform: uppercase;
				margin-bottom: 10px;
			}

			.input-group {
				display: flex;
				height: 35px;
				margin-bottom: 10px;

				.input-label {
					align-self: center;
					width: 105px;
					text-align: left;

					label {
						color: #d9d9d9;
					}
				}
				.input {
					margin-left: auto;
					display: flex;

					input {
						align-self: center;
						background-color: #262628;
						border: none;
						height: 20px;
						font-size: 14px;
						color: #fff;
						padding: 0 5px;
					}
				}
			}

			.form-submit-btn {
				position: absolute;
				bottom: -20px;
				left: 50%;
				transform: translateX(-50%);

				button {
					height: auto;
					.button-inner {
						font-size: 24px;
					}
				}
			}
		}
	}
}
</style>

